module.exports = __webpack_public_path__ + "media/img/astrounauta-woman-e168c424.png";